// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 20px;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: #fff;
  border-collapse: collapse;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  table-layout: fixed;
}

.table th,
.table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table thead th {
  background-color: #007bff;
  color: white;
  font-weight: bold;
}

.table tbody tr:hover {
  background-color: #f1f1f1;
}

.table tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.circular-button {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 20px;
  position: relative;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  bottom: 20px;
  right: -95%;
  top: -25px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s;
}

.circular-button:hover {
  background-color: #0056b3;
}

.deleteImg {
  width: 20px;
  height: 20px;
}

.editImg {
  width: 20px;
  height: 20px;
}

.custom-button:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.custom-button {
  display: inline-block;
  padding: 5px 10px;
  margin: 2px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
}

.success {
  background-color: #28a745;
  color: white;
}

.warning {
  background-color: #ffc107;
  color: white;
}

.error {
  background-color: lightgrey;
  cursor: not-allowed;
}

.info {
  background-color: #17a2b8;
  color: white;
}

.table-input {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.line-through {
  text-decoration: line-through;
}

.light-slate-grey {
  color: lightslategray;
}

.btnAdminManage {
  width: 100px;
}

.modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
  column-gap: 30px;
}

.danger {
  background-color: #d4504c;
  color: white !important;
}

.danger:hover {
  background-color: #c41e17;
  color: white !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/Components/UsersAdministration/tabs/balance-tab/balance-tab.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":[".table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  margin-top: 20px;\n}\n\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  background-color: #fff;\n  border-collapse: collapse;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  table-layout: fixed;\n}\n\n.table th,\n.table td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.table thead th {\n  background-color: #007bff;\n  color: white;\n  font-weight: bold;\n}\n\n.table tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n.table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.circular-button {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  font-size: 20px;\n  position: relative;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  bottom: 20px;\n  right: -95%;\n  top: -25px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n  transition: background-color 0.3s;\n}\n\n.circular-button:hover {\n  background-color: #0056b3;\n}\n\n.deleteImg {\n  width: 20px;\n  height: 20px;\n}\n\n.editImg {\n  width: 20px;\n  height: 20px;\n}\n\n.custom-button:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.custom-button {\n  display: inline-block;\n  padding: 5px 10px;\n  margin: 2px;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center;\n}\n\n.success {\n  background-color: #28a745;\n  color: white;\n}\n\n.warning {\n  background-color: #ffc107;\n  color: white;\n}\n\n.error {\n  background-color: lightgrey;\n  cursor: not-allowed;\n}\n\n.info {\n  background-color: #17a2b8;\n  color: white;\n}\n\n.table-input {\n  width: 100%;\n  padding: 10px;\n  box-sizing: border-box;\n  font-size: 14px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n.line-through {\n  text-decoration: line-through;\n}\n\n.light-slate-grey {\n  color: lightslategray;\n}\n\n.btnAdminManage {\n  width: 100px;\n}\n\n.modal-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: flex-start;\n  column-gap: 30px;\n}\n\n.danger {\n  background-color: #d4504c;\n  color: white !important;\n}\n\n.danger:hover {\n  background-color: #c41e17;\n  color: white !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
